import { Component, EventEmitter, inject, input, Output } from '@angular/core';
import { UiService } from '@services/ui.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { EpxSvgIconComponent } from '@shared/components/misc/epx-svg-icon/epx-icon.component';
import { AppVersionComponent } from '@shared/components/utils/app-version/app-version.component';
import { IMenuItemExtended } from '@shared/interfaces/menu.interface';
import { EpxLangSelectComponent } from '@shared/components/misc/epx-lang-select/epx-lang-select.component';

@Component({
    selector: 'app-dashboard-menu',
    templateUrl: './main-menu.component.html',
    styleUrls: ['./main-menu.component.scss'],
    imports: [RouterModule, CommonModule, TooltipModule, EpxSvgIconComponent, EpxLangSelectComponent, ButtonModule, AppVersionComponent, SvgIconComponent, TranslatePipe]
})
export class MainMenuComponent {
    topMenu: IMenuItemExtended[];
    theme = input<'light' | 'dark'>('light');
    sidebarOpen = input<boolean>(false);
    @Output() sidebarToggleEvent = new EventEmitter();
    protected uiService = inject(UiService);
    private translate = inject(TranslateService);

    constructor() {
        this.topMenu = [
            {
                label: 'MAIN_NAVIGATION.DASHBOARD',
                id: 'sidenav-dashboard-link',
                svgIcon: 'dashboard',
                routerLink: '/dashboard'
            },
            {
                label: 'MODULE_BENEFIT.BENEFIT.PLURAL',
                id: 'sidenav-benefits-link',
                svgIcon: 'benefits',
                routerLink: '/benefits'
            },
            {
                label: 'MODULE_BENEFIT.TYPES.SUBSIDY.PLURAL',
                id: 'sidenav-subsidies-link',
                svgIcon: 'subsidies',
                routerLink: '/applications'
            },
            {
                label: 'MODULE_EMPLOYEE.EMPLOYEE.PLURAL',
                id: 'sidenav-employees-link',
                svgIcon: 'user',
                routerLink: '/employees'
            },
            {
                label: 'MODULE_EXPORTS.EXPORTS.PLURAL',
                id: 'sidenav-exports-link',
                svgIcon: 'download',
                routerLink: 'exports'
            },
            {
                label: 'MODULE_IAM.IAM_SHORT',
                id: 'sidenav-iam-link',
                svgIcon: 'users',
                routerLink: '/iam',
                visible: true
            }
        ];
    }
}
